import { render, staticRenderFns } from "./OrderStatistics.vue?vue&type=template&id=34910075&scoped=true&"
import script from "./OrderStatistics.vue?vue&type=script&lang=js&"
export * from "./OrderStatistics.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatistics.vue?vue&type=style&index=0&id=34910075&lang=less&scoped=true&"
import style1 from "./OrderStatistics.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34910075",
  null
  
)

export default component.exports